import React from 'react';
import PropTypes from 'prop-types';

class OptionTable02 extends React.Component{
    render(){
        const {data} = this.props;
        return(
            <div className="divTable">
                <div className="divTableBody">
                    <div className="divTableRow">
                        <div className="divTableCell" style={{"borderRight":"1px solid #999999"}}>
                            <div className="divTableCellOption">configuration file</div>
                            <div className="divTableCellContent">
                                {data.options.map( (option, index)=>{
                                    return (
                                        <p key={index}>
                                            {option.map( (op, index)=>{
                                                return <label key={index}>{op}<br/></label>
                                            })}
                                        <br/></p>
                                    );
                                })}
                            </div>
                        </div>
                        <div className="divTableCellDetail">
                        <div className="divTableCellOption">option description</div><br/>
							<div className="divTableCellContent">
								{data.descs.map( (obj, index)=>{
                                    return(
                                        <label key={index}>
                                            {obj.op} : &nbsp;{obj.desc}<br/><br/>
                                        </label>
                                    );
                                })}
						    </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

OptionTable02.propTypes={
    data: PropTypes.object.isRequired,
}
export default OptionTable02;